
const VERSION = {
  SHA1:'0fe79c6b5404da9b736c070152c12a298bc25c78',
  VERSION:2352,
  BRANCH:'main',
  PROJECT:'ostium-ne'
}
export default VERSION;
